import React, { useEffect } from 'react'
import './InfoCard.css'
import { useDisclosure } from '@mantine/hooks';
import { Modal, useMantineTheme } from '@mantine/core';
import { useSelector } from 'react-redux';
import { generateUserTypeIcon } from '../../../tools/userTypeConversion';
import { BiEditAlt } from 'react-icons/bi';
import UserView from '../../User/UserView'
import { RiProfileLine } from 'react-icons/ri';
import { MdArrowForwardIos } from 'react-icons/md';

const InfoCard = ( {profileContent, setProfileContent} ) => {

  const {user} = useSelector((state) => state.authReducer.authData);
  
  const [opened, { open, close }] = useDisclosure(false);
  const theme = useMantineTheme();

  const generateUserType = () => {
    switch (user.userType) {
      case 0: 
        return "General";
      case 1: 
        return "Author";
      case 2: 
        return "Group";
    }
  }

  const handleInfoCardCollapse = () => {
    const container = document.getElementById("ic_profile_data");
    const expandIcon = document.getElementById("ic_expand_icon");

    if (container.style.maxHeight === "0px" || container.style.maxHeight === "") {
        container.style.maxHeight = container.scrollHeight + "px";
    } else {
        container.style.maxHeight = "0px";
    }
    expandIcon.classList.toggle("profile-contracted2");
  }

//   useEffect(()=>{
//     if (!document.getElementById("ic_profile_data").classList.contains("General-hidden")) {
//         handleInfoCardCollapse();
//     }
// }, profileContent)

  const modalSize = () => {
    const width = window.innerWidth;
    if (width < 650) {
      return width * 0.8;
    } else {
      return 575;
    }
  }

  return (
    <div className="AppGeneralCard">
        <div id="ic_wrapper" className="InfoCard-wrapper">
            <div className="generalBar">
                <RiProfileLine/>
                <span className='pointText'>
                    My Profile
                </span>
                <span id="ic_expand_icon" className="profile-expand-icon2"><MdArrowForwardIos onClick={handleInfoCardCollapse} /></span>
                <span className="ic-edit-icon"><BiEditAlt onClick={()=>setProfileContent("editProfile")} /></span>
            </div>
            <div id="ic_profile_data" className='ic-profile-data'>

              <div className="ic-line FlexRow">
                  <span className="ic-inline-tag">Name</span>
                  <span className="ic-value">{user.displayname}</span>
              </div>
              <div className="ic-line FlexRow">
                  <span className="ic-inline-tag">Username</span>
                  <span className="ic-value">@{user.username}</span>
              </div>
              <div className="ic-line FlexRow">
                  <span className="ic-inline-tag">User Type</span>
                  <span className="ic-value FlexRow">{generateUserType()}{generateUserTypeIcon(user.userType)}</span>
              </div>
              <div className="ic-line">
                  <span className="ic-tag">Tagline</span>
              </div>
              <div className="ic-line">
                  <span className="ic-dropped-value">{user.tagline}</span>
              </div>
              <div className="ic-line">
                  <span className="ic-tag">Statement</span>
              </div>
              <div className="ic-line">
                <span
                  className="ic-dropped-value"
                  dangerouslySetInnerHTML={{ __html: user.statement }}
                >
                </span>
              </div>
              
              <hr/>

              <div className="AppGeneralEditLine" onClick={open}>
              View Profile        
              </div>
            </div>
  
        </div>

        <Modal
        opened={opened}
        onClose={close}
        overlayProps={{
          color: theme.colorScheme === 'dark' ? theme.colors.dark[9] : theme.colors.gray[2],
          opacity: 0.55,
          blur: 3,
        }}
        size={modalSize()}
        withCloseButton={false}
      >
        <UserView user={user} />            
      </Modal>
    </div>
  )
}

export default InfoCard